import React from "react";
import testimonialVideo from "../assets/testimonial.webm"; // Update path as needed
// import testimonialThumbnail from "../assets/testimonial-thumbail.png"; // Optional thumbnail

const TestimonialSection = () => {
  return (
    <section className="bg-white dark:bg-gray-900 py-16 px-4 sm:px-6">
      <div className="max-w-screen-xl mx-auto text-center">
        {/* Heading */}
        <h2 className="text-3xl sm:text-4xl font-serif font-bold text-gray-800 dark:text-white mb-4 animate-fade-in">
          What People Are Saying
        </h2>
        <p className="text-lg sm:text-xl text-gray-600 dark:text-gray-300 mb-10 animate-fade-in">
          Real feedback from real users—plus a look at their experience.
        </p>

        {/* Testimonial Quote */}
        <figure className="max-w-2xl mx-auto mb-12">
          <svg
            className="h-10 mx-auto mb-4 text-gray-300 dark:text-gray-600"
            viewBox="0 0 24 27"
            fill="none"
          >
            <path
              d="M14.017 18L14.017 10.609C14.017 4.905 17.748 1.039 23 0L23.995 2.151C21.563 3.068 20 5.789 20 8H24V18H14.017ZM0 18V10.609C0 4.905 3.748 1.038 9 0L9.996 2.151C7.563 3.068 6 5.789 6 8H9.983L9.983 18L0 18Z"
              fill="currentColor"
            />
          </svg>
          <blockquote>
            <p className="text-2xl font-medium text-gray-900 dark:text-white">
              “Effie changed the game for us. It's like having a 24/7 assistant
              that always knows exactly what to say.”
            </p>
          </blockquote>
          <figcaption className="flex items-center justify-center mt-6 space-x-3">
            {/* <img
              className="w-8 h-8 rounded-full"
              src="https://randomuser.me/api/portraits/women/44.jpg"
              alt="User Avatar"
            /> */}
            <div className="flex items-center divide-x-2 divide-gray-400 dark:divide-gray-600">
              <div className="pr-3 font-medium text-gray-900 dark:text-white">
                Barbara S.
              </div>
              <div className="pl-3 text-sm text-gray-500 dark:text-gray-400">
                Operations Manager, Ascend Dental Education
              </div>
            </div>
          </figcaption>
        </figure>

        {/* Testimonial Video */}
        <div className="relative w-full max-w-3xl mx-auto pb-[56.25%] bg-gray-900 rounded-lg overflow-hidden shadow-lg animate-fade-in">
          <video
            className="absolute top-0 left-0 w-full h-full object-contain rounded-lg"
            controls
            playsInline
            // poster={testimonialThumbnail}
          >
            <source src={testimonialVideo} type="video/webm" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      {/* Animation Styling */}
      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        .animate-fade-in {
          animation: fade-in 1s ease-out forwards;
        }
      `}</style>
    </section>
  );
};

export default TestimonialSection;
